import React from "react";

const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] py-6">
      <div className="container mx-auto text-center">
        <h2 className="text-lg font-bold mb-4 text-[#f2932c]">Connect</h2>
        <p className="text-gray-50 text-sm">
         samir.niroula001@gmail.com
        </p>
      </div>
    </footer>
  );
};

export default Footer;
